export const USERS_REQUEST = 'USERS_REQUEST'
export const USERS_SET_QUERY = 'USERS_SET_QUERY'
export const USERS_REQUEST_GUIDELINES_AND_PUBLICATION_COUNCIL = 'USERS_REQUEST_GUIDELINES_AND_PUBLICATION_COUNCIL'
export const USERS_REQUEST_COMMITTEE_USERS = 'USERS_REQUEST_COMMITTEE_USERS'
export const USERS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS = 'USERS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS'
export const USERS_SUCCESS = 'USERS_SUCCESS'
export const USERS_ERROR = 'USERS_ERROR'
export const USERS_EMPTY = 'USERS_EMPTY'
export const USERS_IMPORT = 'USERS_IMPORT'
export const USERS_IMPORT_CHECK = 'USERS_IMPORT_CHECK'
